import { RootState } from '@iwProvider/configureStore';

export const getDrawdownAmount = (state: RootState) =>
    state?.api?.offer_configuration?.data?.cash_amount;

export const getRBLDrawdownSweep = (state: RootState) =>
    state?.api?.offer_configuration?.data?.revenue_sweep_fraction;
